module.exports = __webpack_public_path__ + "3e2153cc41b65dd3c367135b260a77dc.svg";